export const FETCH_BILLING_PLANS = "app/Billing/FETCH_BILLING_PLANS";
export const FETCH_BILLING_PLANS_SUCCESS =
  "app/Billing/FETCH_BILLING_PLANS_SUCCESS";
export const FETCH_BILLING_PLANS_FAILURE =
  "app/Billing/FETCH_BILLING_PLANS_FAILURE";

export const START_BILLING_CHECKOUT = "app/Billing/START_BILLING_CHECKOUT";
export const START_BILLING_CHECKOUT_SUCCESS =
  "app/Billing/START_BILLING_CHECKOUT_SUCCESS";
export const START_BILLING_CHECKOUT_FAILURE =
  "app/Billing/START_BILLING_CHECKOUT_FAILURE";

export const CONFIRM_BILLING_CHECKOUT = "app/Billing/CONFIRM_BILLING_CHECKOUT";
export const CONFIRM_BILLING_CHECKOUT_SUCCESS =
  "app/Billing/CONFIRM_BILLING_CHECKOUT_SUCCESS";
export const CONFIRM_BILLING_CHECKOUT_FAILURE =
  "app/Billing/CONFIRM_BILLING_CHECKOUT_FAILURE";

export const CHANGE_BILLING_PLAN = "app/Billing/CHANGE_BILLING_PLAN";
export const CHANGE_BILLING_PLAN_SUCCESS =
  "app/Billing/CHANGE_BILLING_PLAN_SUCCESS";
export const CHANGE_BILLING_PLAN_FAILURE =
  "app/Billing/CHANGE_BILLING_PLAN_FAILURE";
export const PREVIEW_BILLING_PLAN_CHANGE =
  "app/Billing/PREVIEW_BILLING_PLAN_CHANGE";
export const PREVIEW_BILLING_PLAN_CHANGE_SUCCESS =
  "app/Billing/PREVIEW_BILLING_PLAN_CHANGE_SUCCESS";
export const PREVIEW_BILLING_PLAN_CHANGE_FAILURE =
  "app/Billing/PREVIEW_BILLING_PLAN_CHANGE_FAILURE";
export const CLEAR_BILLING_PLAN_PREVIEW =
  "app/Billing/CLEAR_BILLING_PLAN_PREVIEW";

export const CANCEL_BILLING = "app/Billing/CANCEL_BILLING";
export const CANCEL_BILLING_SUCCESS = "app/Billing/CANCEL_BILLING_SUCCESS";
export const CANCEL_BILLING_FAILURE = "app/Billing/CANCEL_BILLING_FAILURE";

export const UPDATE_BILLING_QUANTITY = "app/Billing/UPDATE_BILLING_QUANTITY";
export const UPDATE_BILLING_QUANTITY_SUCCESS =
  "app/Billing/UPDATE_BILLING_QUANTITY_SUCCESS";
export const UPDATE_BILLING_QUANTITY_FAILURE =
  "app/Billing/UPDATE_BILLING_QUANTITY_FAILURE";
